import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Login'
import Logout from '@/components/Logout'

import Services from '@/components/resources/Services'
import Products from '@/components/resources/Products'
import Inventories from '@/components/resources/Inventories'
import Plans from '@/components/resources/Plans'
import Users from '@/components/resources/Users'
import Clients from '@/components/resources/Clients'
import Cases from '@/components/resources/Cases'
import Profile from '@/components/Profile'
import AddLeadForm from '@/components/AddLeadForm'
import AddLeadFormOld from '@/components/AddLeadFormOld'
import SelectPlanAndVendors from '@/components/SelectPlanAndVendors'
import InventoryReport from '@/components/InventoryReport'
// import NewLeads from '@/components/NewLeads'
import Bookings from '@/components/resources/Bookings'
import VendorsInvoice from '@/components/VendorsInvoice'
import WhatsappNotifications from '@/components/resources/WhatsappNotifications'
// import TwilioNotifications from '@/components/resources/TwilioNotifications'
import CasesDetail from '@/components/detail/CasesDetail'
import PDFTemplates from '@/components/PDFTemplates'
import Roles from '@/components/resources/Roles'
import OnboardClient from '@/components/OnboardClient'
import Notifications from '@/components/resources/Notifications'
// import Forms from '@/components/resources/Forms'
import Analytics from '@/components/resources/Analytics'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      secure: true,
      meta: {
        can: 'view Home',
        fail: '/login'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      secure: false,
      meta: {
        can: 'view Login'
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
      secure: true,
      meta: {
        can: 'view Logout',
        fail: '/'
      }
    },
    {
      path: '/services',
      name: 'Services',
      component: Services,
      secure: true,
      meta: {
        can: 'view Services',
        fail: '/'
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      secure: true,
      meta: {
        can: 'view Products',
        fail: '/'
      }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      secure: true,
      meta: {
        can: 'view Profile',
        fail: '/'
      }
    },
    {
      path: '/inventories',
      name: 'Inventories',
      component: Inventories,
      secure: true,
      meta: {
        can: 'view Inventories',
        fail: '/'
      }
    },
    {
      path: '/plans',
      name: 'Plans',
      component: Plans,
      secure: true,
      meta: {
        can: 'view Plans',
        fail: '/'
      }
    },
    {
      path: '/users',
      name: 'Users',
      component: Users,
      secure: true,
      meta: {
        can: 'view Users',
        fail: '/'
      }
    },
    {
      path: '/clients',
      name: 'Clients',
      component: Clients,
      secure: true,
      meta: {
        can: 'view Clients',
        fail: '/'
      }
    },
    {
      path: '/cases',
      name: 'Cases',
      component: Cases,
      props: {
        detailCaseButtonActionIsDefault: true
      },
      secure: true,
      meta: {
        can: 'view Cases',
        fail: '/'
      }
    },
    {
      path: '/new-lead',
      name: 'AddLeadForm',
      component: AddLeadForm,
      secure: true,
      meta: {
        can: 'view AddLeadForm',
        fail: '/'
      }
    },
    {
      path: '/assign-crew-and-timing',
      name: 'NewLeads',
      component: AddLeadFormOld,
      props: true,
      // component: NewLeads,
      secure: true,
      meta: {
        can: 'view NewLeads',
        fail: '/'
      }
    },
    {
      path: '/select-plan-and-vendors',
      name: 'SelectPlanAndVendors',
      component: SelectPlanAndVendors,
      props: true,
      secure: true,
      meta: {
        can: 'view SelectPlanAndVendors',
        fail: '/'
      }
    },
    {
      path: '/appointment-schedule',
      name: 'AppointmentSchedule',
      component: AddLeadForm,
      props: {
        forCaseManager: true
      },
      secure: true,
      meta: {
        can: 'view AppointmentSchedule',
        fail: '/'
      }
    },
    {
      path: '/bookings',
      name: 'Bookings',
      component: Bookings,
      secure: true,
      meta: {
        can: 'view Bookings',
        fail: '/'
      }
    },
    {
      path: '/cases/:id/upload_invoice',
      name: 'VendorsInvoice',
      component: VendorsInvoice,
      props: true,
      secure: false,
      meta: {
        can: 'view VendorsInvoice',
        fail: '/'
      }
    },
    {
      path: '/notifications/whatsapp',
      name: 'WhatsappNotifications',
      component: WhatsappNotifications,
      secure: true,
      meta: {
        can: 'view WhatsappNotifications',
        fail: '/'
      }
    },
    // {
    //   path: '/notifications/sms',
    //   name: 'SMSNotifications',
    //   component: TwilioNotifications,
    //   secure: true,
    //   meta: {
    //     can: 'view SMSNotifications',
    //     fail: '/'
    //   }
    // },
    {
      path: '/reminders',
      name: 'Reminders',
      component: Notifications,
      secure: true,
      meta: {
        can: 'view Reminders',
        fail: '/'
      }
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics,
      secure: true,
      meta: {
        can: 'view Analytics',
        fail: '/'
      }
    },
    {
      path: '/notifications',
      name: 'SMSNotifications',
      component: Notifications,
      secure: true,
      meta: {
        can: 'view Notifications',
        fail: '/'
      }
    },
    {
      path: '/cases/:id',
      name: 'CasesDetail',
      component: CasesDetail,
      props: true,
      secure: true,
      meta: {
        can: 'view CasesDetail',
        fail: '/'
      }
    },
    {
      path: '/templates',
      name: 'PDFTemplates',
      component: PDFTemplates,
      secure: true,
      meta: {
        can: 'view PDFTemplates',
        fail: '/'
      }
    },
    {
      path: '/roles',
      name: 'Roles',
      component: Roles,
      secure: true,
      meta: {
        can: 'view Roles',
        fail: '/'
      }
    },
    {
      path: '/onboard-client',
      name: 'OnboardClient',
      component: OnboardClient,
      secure: true,
      props: true,
      meta: {
        can: 'view OnboardClient',
        fail: '/'
      }
    },
    {
      path: '/event-checklist',
      name: 'EventChecklist',
      component: Cases,
      props: {
        detailCaseButtonActionIsGoToCheckListsTab: true
      },
      secure: true,
      meta: {
        can: 'view EventChecklist',
        fail: '/'
      }
    },
    {
      path: '/event-crew',
      name: 'SelectCrew',
      component: Cases,
      props: {
        crewSelecting: true
      },
      secure: true,
      meta: {
        can: 'view SelectCrew',
        fail: '/'
      }
    },
    {
      path: '/billing',
      name: 'Billing',
      component: Cases,
      props: {
        detailCaseButtonActionIsGoToInvoicesTab: true
      },
      secure: true,
      meta: {
        can: 'view Billing',
        fail: '/'
      }
    },
    {
      path: '/inventory-report',
      name: 'InventoryReport',
      component: InventoryReport,
      secure: true,
      meta: {
        can: 'view InventoryReport',
        fail: '/'
      }
    }
    // {
    //   path: '/forms',
    //   name: 'Forms',
    //   component: Forms,
    //   secure: true
    // }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js